import { render, staticRenderFns } from "./StateBlogModal.vue?vue&type=template&id=815b7442&"
import script from "./StateBlogModal.vue?vue&type=script&lang=js&"
export * from "./StateBlogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports